function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createMuiTheme } from '@material-ui/core';
import { lightPalette, darkPalette } from "./palette.js";
import { typography } from "./typography.js";
export const lightTheme = createMuiTheme({
  palette: _objectSpread({}, lightPalette, {
    type: 'light'
  }),
  typography: {
    fontFamily: "Ubuntu, 'sans-serif'",
    h6: {
      color: lightPalette.tundora,
      fontSize: typography.sizes.h6,
      fontWeight: 600
    },
    body1: {
      color: lightPalette.doveGray
    },
    subtitle2: {
      color: lightPalette.common.white
    }
  },
  overrides: {
    MuiFormControl: {
      root: {
        minHeight: 90
      }
    },
    MuiFormHelperText: {
      root: {
        '&:Mui-Error': {
          color: lightPalette.error.dark
        }
      }
    }
  }
});
export const darkTheme = createMuiTheme({
  palette: _objectSpread({}, darkPalette, {
    type: 'dark'
  }),
  typography: {
    fontFamily: "Ubuntu, 'sans-serif'"
  }
});